import { useDispatch } from 'react-redux';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

export default function useThunkDispatch<State = unknown>() {
  return useDispatch<ThunkDispatch<State, void, AnyAction>>();
}
